import { translationUploadManager } from "./TranslationUpload.slice";

export const translationUploadActions = { ...translationUploadManager.actions };
